import { RoleInterface } from "../RoleInterface";
import { Role } from "../Role";
import Translator from "../../../../../Translation/Translator";

class Tenant extends Role implements RoleInterface  {

  public static contactRoleId: number = 4;

  public getName(): string {
    return Translator.trans("role-tenant");
  }

}

export { Tenant }
